import { Component, OnInit } from '@angular/core';
import{ApiService} from '../../services/api.service';
@Component({
  selector: 'app-ekskul',
  templateUrl: './ekskul.page.html',
  styleUrls: ['./ekskul.page.scss'],
})
export class EkskulPage implements OnInit {

  constructor(private api:ApiService) { }

  ngOnInit() {
  		this.getData();
  }
  dataEkskul:any=[];
  getData()
  {
  		var keyApp=localStorage.getItem('keyApp');
  		this.api.data('ekskul?key_app='+keyApp,'get','').subscribe(data=>{  			
  			this.dataEkskul=data;
  		})
  }

  sliderAdds = {
    freeMode: false,
    slidesPerView: 1,
    spaceBetween: 10,
    centeredSlides: true,
    pagination: {
      el: '.swiper-pagination',
      dynamicBullets: true,
    },
    loop: true,
      autoplay: {
      delay: 5000,
    },
  };

}
